module.exports = __webpack_public_path__ + "img/Comic06-1.d45a3be8.png";